class SMSPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.modal = this.querySelector('dialog');
    this.backdrop = this.querySelector('.loyalty-popup__backdrop');
    this.closeBtn = this.querySelector('button#close');

    this.cookieDays = parseInt(this.modal.dataset.cookieDays);
    this.cookieName = 'loyaltyPopupShown';
    this.sessionKey = 'loyaltyPopupShownThisSession';

    const isEnabled = this.modal.dataset.popupEnabled === 'true';
    const showDelay = parseInt(this.modal.dataset.showDelay) * 1000;

    if (isEnabled && !this.getCookie(this.cookieName) && !this.getSessionFlag()) {
      const showPopup = this.showPopup.bind(this);
      setTimeout(showPopup, showDelay);
    }
    const _this = this;
    this.modal.addEventListener('close', () => {
      // Always set session flag (no consent needed for sessionStorage)
      _this.setSessionFlag();
      // Only set cookie if user consented
      _this.setCookie(_this.cookieName, 'true', _this.cookieDays);
    });

    this.addEventListener('click', e => {
      if (e.target == this.modal) _this.hidePopup();
    });

    this.closeBtn.addEventListener('click', () => _this.hidePopup());

    this.modal.addEventListener('keyup', e => {
      if (e.key == 'Escape') {
        _this.hidePopup();
      }
    });
  }

  isConsentGiven() {
    if (typeof _iub !== 'undefined' && _iub.cs && _iub.cs.api) {
      return _iub.cs.api.isConsentGiven();
    }
    return false;
  }

  setCookie(name, value, days) {
    // Only set cookie if user has consented
    if (!this.isConsentGiven()) {
      console.log('Cookie consent not given, skipping cookie');
      return;
    }
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
  }

  getCookie(name) {
    return document.cookie.split('; ').reduce((r, v) => {
      const parts = v.split('=');
      return parts[0] === name ? decodeURIComponent(parts[1]) : r;
    }, '');
  }

  setSessionFlag() {
    try {
      sessionStorage.setItem(this.sessionKey, 'true');
    } catch (e) {
      console.error('SessionStorage not available:', e);
    }
  }

  getSessionFlag() {
    try {
      return sessionStorage.getItem(this.sessionKey) === 'true';
    } catch (e) {
      return false;
    }
  }

  showPopup() {
    this.modal.showModal();
  }

  hidePopup() {
    this.modal.close();
    // Always set session flag (no consent needed for sessionStorage)
    this.setSessionFlag();
    // Only set cookie if user consented
    this.setCookie(this.cookieName, 'true', this.cookieDays);
  }
}

customElements.define('sms-popup', SMSPopup);
